var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 6.66667V5.83333C13.3334 3.99239 11.841 2.5 10.0001 2.5V2.5C8.15913 2.5 6.66675 3.99239 6.66675 5.83333V6.66667",
    stroke: "white",
    strokeWidth: 1.58333,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19562 6.529C2.5 7.22462 2.5 8.3442 2.5 10.5834V12C2.5 14.9856 2.5 16.4784 3.4275 17.4059C4.35499 18.3334 5.84777 18.3334 8.83333 18.3334H11.1667C14.1522 18.3334 15.645 18.3334 16.5725 17.4059C17.5 16.4784 17.5 14.9856 17.5 12V10.5834C17.5 8.3442 17.5 7.22462 16.8044 6.529C16.1088 5.83337 14.9892 5.83337 12.75 5.83337H7.25C5.01083 5.83337 3.89124 5.83337 3.19562 6.529ZM10 12.5833C10.5063 12.5833 10.9167 12.1729 10.9167 11.6666C10.9167 11.1604 10.5063 10.75 10 10.75C9.49374 10.75 9.08333 11.1604 9.08333 11.6666C9.08333 12.1729 9.49374 12.5833 10 12.5833ZM12.5 11.6666C12.5 12.7706 11.7844 13.7075 10.7917 14.0387V15.8334H9.20833V14.0387C8.21564 13.7075 7.5 12.7706 7.5 11.6666C7.5 10.2859 8.61929 9.16662 10 9.16662C11.3807 9.16662 12.5 10.2859 12.5 11.6666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockFill);
export default __webpack_public_path__ + "static/media/lock_fill.ce210eb50f3b43806c8b11881a93e8fe.svg";
export { ForwardRef as ReactComponent };